<script lang="ts" setup>
import {
  AppLink,
} from '#components'

import { useDynamicIcons } from '~layers/shared/utils/useDynamicIcons.ts'

const { loadLayout, layoutData } = useLayout()
await loadLayout()

function getElement(to: string | null | undefined) {
  return to ? AppLink : 'span'
}

const { loadIcon } = useDynamicIcons()
</script>

<template>
  <div
    v-if="layoutData?.paymentIcons?.[0]"
    class="payment-icons"
  >
    <div
      v-if="layoutData?.paymentIcons[0]?.Title"
      class="payment-icons__title"
    >
      {{ layoutData?.paymentIcons[0].Title }}
    </div>

    <ul
      v-if="layoutData?.paymentIcons?.[0]?.Icons?.length"
      class="payment-icons__list"
    >
      <li
        v-for="(group, index) in layoutData.paymentIcons[0].Icons"
        :key="index"
      >
        <component
          :is="getElement(group.Link)"
          class="payment-icons__link"
          :to="group.Link"
        >
          <Icon
            v-if="group.Icon"
            :name="loadIcon(group.Icon)"
            class="icon"
            :class="`icon--${group.Icon.toLowerCase()}`"
          />
          <span class="payment-icons__label">{{ group.Name }}</span>
        </component>
      </li>
    </ul>
  </div>
</template>

<style>
@import url("~layers/app/components/App/PaymentIcons.css");
</style>
